import moment from 'moment';

export default function generateFilterForQuery(filterOptions: any) {

    const filter: any[] = [];

    if (filterOptions.name) {
        filter.push({ "$ilike": ["deal.name", {"$": `%${filterOptions.name}%`}] })
    }

    if (filterOptions.point_address) {
      filter.push({ "$ilike": ["delivery_points.address", {"$": `%${filterOptions.point_address}%`}] })
    }

    if (filterOptions.dates) {
      filter.push({ $gte: ['deal.expected_delivery_date', { $: moment(filterOptions.dates[0]).format('YYYY-MM-DD') }] })
      filter.push({ $lte: ['deal.expected_delivery_date', { $: moment(filterOptions.dates[1]).format('YYYY-MM-DD') }] })
    }

    if (filterOptions.clientId) {
      const $clientId = Array.isArray(filterOptions.clientId) ? filterOptions.clientId : [filterOptions.clientId]
      if ($clientId.length > 0) {
        filter.push({ $in: ['client.id', { $: $clientId }] })
      }
    }

    if (filterOptions.cities) {
      const $cities = Array.isArray(filterOptions.cities) ? filterOptions.cities : [filterOptions.cities]
      if ($cities.length > 0) {
        filter.push({ $in: ['city.id', { $: $cities }] })
      }
    }
    if (filterOptions.dealId) {
      // console.log(filterOptions.dealId);
      const $dealId = Array.isArray(filterOptions.dealId) ? filterOptions.dealId : [filterOptions.dealId]
      if ($dealId.length > 0) {
        filter.push({ $in: ['deal.id', { $: $dealId }] })
      }
    }

    if (filterOptions.warehouses) {
      const $warehouses = Array.isArray(filterOptions.warehouses) ? filterOptions.warehouses : [filterOptions.warehouses]
      if ($warehouses.length > 0) {
        filter.push({ $in: ['deal.delivery_warehouse_id', { $: $warehouses }] })
      }
    }

    if (filterOptions.clientTypes) {
      const $clientTypes = Array.isArray(filterOptions.clientTypes) ? filterOptions.clientTypes : [filterOptions.clientTypes]
      if ($clientTypes.length > 0) {
        filter.push({ $in: ['client.type_id', { $: $clientTypes }] })
      }
    }

    if (filterOptions.dealsTypes) {
      const $dealsTypes = Array.isArray(filterOptions.dealsTypes) ? filterOptions.dealsTypes : [filterOptions.dealsTypes]
      if ($dealsTypes.length > 0) {
        filter.push({ $in: ['deal.type_id', { $: $dealsTypes }] })
      }
    }

    if (filterOptions.status) {
      filter.push({ $eq: ['deal.status_id', { $: filterOptions.status }] })
    }

    if (filterOptions.deliveryZoneGroups) {
      filter.push({
        $in: [
          'deal.delivery_point_id', {
            columns: {
              id: 'dpdz.delivery_point_id'
            },
            from: 's:delivery_points_delivery_zones',
            from_as: 'dpdz',
            joins: [
              {
                join: 's:delivery_zones',
                type: 'left',
                as:   'delivery_zones',
                on: {
                  $eq: ['dpdz.delivery_zone_id', 'delivery_zones.id']
                }
              },
            ],
            where: {
              $in: ['delivery_zones.delivery_zone_group_id', { $: Array.isArray(filterOptions.deliveryZoneGroups) ? filterOptions.deliveryZoneGroups : [filterOptions.deliveryZoneGroups] }]
            }
          }
        ]
      })
    }

    if (filterOptions.wichSamples) {
      filter.push({ $gt: ['dpc_with_samples.sapmle_count', { $: 0 }] })
    }

    return filter;
}